// extracted by mini-css-extract-plugin
export default {"wrapper":"ApartmentRatingButtons_wrapper__ev61y","buttonAnimation":"ApartmentRatingButtons_buttonAnimation__rmATI","singleButton":"ApartmentRatingButtons_singleButton__3skaP"};